<template>
  <Card class="m-2">
    <template #content="">
      <div class="grid">
        <div class="col-12 md:col-3 lg:col-2 p-fluid">
          <span class="p-float-label">
            <Dropdown
              id="calendar"
              v-model="selectedYear"
              :options="years"
              @change="onSearch"
            ></Dropdown>
            <label for="calendar">ระบุปีที่ต้องการดูรายงาน</label>
          </span>
        </div>
        <div class="col-12 md:col-3 lg:col-2 p-fluid">
          <span class="p-float-label">
            <MultiSelect
              id="monthSelect"
              v-model="selectedMonths"
              :options="months"
            ></MultiSelect>
            <label for="monthSelect">ระบุเดือน</label>
          </span>
        </div>
        <div class="col-12 md:col-3 lg:col-2 p-fluid">
          <span class="p-float-label">
            <MultiSelect
              id="office"
              v-model="selectedOffices"
              :options="offices"
              optionLabel="description"
              optionValue="code"
            ></MultiSelect>
            <label for="office">สาขา</label>
          </span>
        </div>
        <!-- <div class="col-fixed">
          <Button
            icon="pi pi-search"
            @click="onSearch"
            :loading="isLoading"
          ></Button>
        </div> -->
        <div class="col-fixed">
          <Button
            icon="pi pi-download"
            @click="onDownload"
            :loading="isLoading"
            label="Download Excel"
            class="p-button-success"
          ></Button>
        </div>
      </div>
      <TabView v-model:activeIndex="selectedTab">
        <TabPanel header="รายงานตามเดือน">
          <div class="grid">
            <div class="col-12 md:col-6 lg:col-4">
              <PerformanceChart1 :summary="filteredSummary" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <PerformanceChart2 :summary="filteredSummary" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <PerformanceChart3 :summary="filteredSummary" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <PerformanceChart4 :summary="filteredSummary" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <PerformanceChart5 :summary="filteredSummary" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <PerformanceChart6 :summary="filteredSummary" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <PerformanceChart7 :summary="filteredSummary" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <PerformanceChart8 :summary="filteredSummary" />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="รายงานตาม Warehouse">
          <div class="grid">
            <div class="col-12 lg:col-6">
              <PerformanceChartWh1 :summary="filteredSummary" />
            </div>
            <div class="col-12 lg:col-6">
              <PerformanceChartWh2 :summary="filteredSummary" />
            </div>
            <div class="col-12 lg:col-6">
              <PerformanceChartWh3 :summary="filteredSummary" />
            </div>
            <div class="col-12 lg:col-6">
              <PerformanceChartWh4 :summary="filteredSummary" />
            </div>
          </div>
        </TabPanel>
      </TabView>
    </template>
  </Card>
</template>

<script lang="ts">
import { usePlugin } from "@/plugins";
import {
  GetPerformanceReportSummaryRequest,
  GetPerformanceReportSummaryResponse,
  PerformanceReportSummary,
} from "@/types";
import { computed, defineComponent, onMounted, ref } from "vue";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { useSessionStorage } from "@vueuse/core";
import PerformanceChart1 from "@/components/PerformanceChart1.vue";
import PerformanceChart2 from "@/components/PerformanceChart2.vue";
import PerformanceChart3 from "@/components/PerformanceChart3.vue";
import PerformanceChart4 from "@/components/PerformanceChart4.vue";
import PerformanceChart5 from "@/components/PerformanceChart5.vue";
import PerformanceChart6 from "@/components/PerformanceChart6.vue";
import PerformanceChart7 from "@/components/PerformanceChart7.vue";
import PerformanceChart8 from "@/components/PerformanceChart8.vue";
import PerformanceChartWh1 from "@/components/PerformanceChartWh1.vue";
import PerformanceChartWh2 from "@/components/PerformanceChartWh2.vue";
import PerformanceChartWh3 from "@/components/PerformanceChartWh3.vue";
import PerformanceChartWh4 from "@/components/PerformanceChartWh4.vue";
export default defineComponent({
  name: "PerformanceSummaryReport",
  components: {
    PerformanceChart1,
    PerformanceChart2,
    PerformanceChart3,
    PerformanceChart4,
    PerformanceChart5,
    PerformanceChart6,
    PerformanceChart7,
    PerformanceChart8,
    PerformanceChartWh1,
    PerformanceChartWh2,
    PerformanceChartWh3,
    PerformanceChartWh4,
  },
  setup() {
    const { error, axios, dayjs, success } = usePlugin();
    const years = computed(() => {
      const startYear = 2018;
      const endYear = dayjs().year();
      const result = [];
      for (let i = startYear; i <= endYear; i++) {
        result.push(i.toString());
      }
      return result;
    });

    const months = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
    const selectedMonths = ref<number[]>([]);
    const selectedTab = useSessionStorage(
      "PerformanceSummaryReport-selectedTab",
      0
    );
    const selectedYear = useSessionStorage(
      "PerformanceSummaryReport-selectedYear",
      dayjs().year().toString()
    );
    const summary = ref<PerformanceReportSummary[]>([]);
    const selectedOffices = ref<string[]>([]);
    const offices = computed(() => {
      return [
        ...new Set(
          summary.value.map((x) => ({
            code: x.officeCode,
            description: x.office,
          }))
        ),
      ];
    });
    const isLoading = ref(false);

    const filteredSummary = computed(() => {
      if (
        selectedMonths.value.length === 0 &&
        selectedOffices.value.length === 0
      ) {
        return summary.value;
      } else {
        let result = summary.value;
        if (selectedMonths.value.length > 0) {
          result = result.filter(
            (x) => selectedMonths.value.indexOf(parseInt(x.month)) >= 0
          );
        }
        if (selectedOffices.value.length > 0) {
          result = result.filter(
            (x) => selectedOffices.value.indexOf(x.officeCode) >= 0
          );
        }
        return result;
      }
    });

    const onSearch = async () => {
      isLoading.value = true;
      try {
        const result = await axios.post<GetPerformanceReportSummaryResponse>(
          "api/v1/admin/performance/report/summary",
          {
            year: selectedYear.value,
          } as GetPerformanceReportSummaryRequest
        );
        success("ดึงข้อมูลสำเร็จแล้ว");
        summary.value = result.data.summary ?? [];
      } catch (e) {
        error(e);
      } finally {
        isLoading.value = false;
      }
    };

    const onDownload = async () => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("POD Summary Status");

      worksheet.getCell("A1").value = `รายงานเมื่อ ${dayjs().format(
        "DD MMMM YYYY HH:mm:ss"
      )}`;
      worksheet.getCell("A2").value = `ปี ${selectedYear.value}`;
      worksheet.getCell("A3").value = `เดือน : ${
        selectedMonths.value.length === 0
          ? "ทั้งหมด"
          : selectedMonths.value.join(",")
      }`;
      worksheet.getCell("A4").value = `Warehouse: ${
        selectedOffices.value.length === 0
          ? "ทั้งหมด"
          : selectedOffices.value.join(",")
      }`;

      worksheet.addTable({
        name: "SummaryTable",
        ref: "A5",
        columns: [
          { name: "Year", filterButton: true },
          { name: "Month", filterButton: true },
          { name: "Warehouse Code", filterButton: true },
          { name: "Warehouse Name", filterButton: true },
          { name: "จำนวนลูกค้า", filterButton: true },
          { name: "จำนวนเอกสารทั้งหมด", filterButton: true },
          { name: "จำนวนเอกสารที่ส่งสำเร็จ", filterButton: true },
          { name: "จำนวนลังทั้งหมด", filterButton: true },
          { name: "จำนวนลังที่ส่งสำเร็จ", filterButton: true },
          { name: "จำนวน Helpers", filterButton: true },
          { name: "ระยะเวลาทั้งหมด (วินาที)", filterButton: true },
          { name: "จำนวนรอบี", filterButton: true },
        ],
        rows: filteredSummary.value.map((x) => {
          return [
            parseInt(x.year),
            parseInt(x.month),
            x.officeCode,
            x.office,
            x.customers,
            x.docAssign,
            x.docSuccess,
            x.caseAssign,
            x.caseSuccess,
            x.helpers,
            x.duration,
            x.totalShipments,
          ];
        }),
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer]);
      saveAs(
        blob,
        `performance_summary_${dayjs().format("YYYY-MM-DD HH:mm:ss")}.xlsx`
      );
    };

    onMounted(() => {
      onSearch();
    });

    return {
      summary,
      onSearch,
      onDownload,
      selectedYear,
      years,
      isLoading,
      offices,
      selectedOffices,
      selectedTab,
      months,
      selectedMonths,
      filteredSummary,
    };
  },
});
</script>
